//@config
export default {
  cooperation: {
    order: "v1/order",
    order_id: "v1/order/{0}",
    company_combo: "v1/company/combo",
    parvandeh_combo: "v1/parvandeh_combo",
    payment_rule: "v1/payment_rule",
    payment_rule_id: "v1/payment_rule/{0}",
    payment_rule_parvandeh: "v1/payment_rule_parvandeh",
    parvandeh_payment_cooperation: "v1/parvandeh/{0}/payment_cooperation",
    payment_cooperation: "v1/payment_cooperation",
    payment_cooperation_id: "v1/payment_cooperation/{0}",
    daily_working: "v1/daily_working",
    daily_working_id: "v1/daily_working/{0}",
    payment_rule_combo: "v1/payment_rule_combo",
    order_combo: "v1/order_combo",
    cooperation_parvandeh_combo: "v1/cooperation_parvandeh_combo",
    order_report_id: "v1/order_report/{0}",
    financial_report: "v1/financial_report/{0}",
    myPaymentRuleParvandeh: "v1/my-payment-rule-parvandeh",
    myFinancialReport: "v1/my-financial-report/{0}",
    myDailyWorking: "v1/my-daily-working/{0}",
    myParvandehPayment: "v1/parvandeh/{0}/my-payment-cooperation",
  },
};
